import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rounded-3 mb-4 for-dark",
  style: {"background-color":"#dde4ff"}
}
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-55px -11px -30px -12px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"mb-4\"><h3 class=\"mb-0\"> Instagram Campaigns <span class=\"bg-danger bg-opacity-10 text-danger fs-12 py-1 px-2 rounded-1\"> Live Now </span></h3></div><div class=\"d-flex justify-content-between mb-3\"><div><div class=\"d-flex align-items-center mb-2\"><span class=\"d-inline-block rounded-circle bg-primary-div position-relative top-1\" style=\"width:10px;height:10px;\"></span><span class=\"ms-2\">Campaign Budget</span></div><h3 class=\"fs-24 mb-0\">$3200</h3></div><div><div class=\"d-flex align-items-center mb-2\"><span class=\"d-inline-block rounded-circle bg-danger position-relative top-1\" style=\"width:10px;height:10px;\"></span><span class=\"ms-2\">Followers Goal</span></div><h3 class=\"fs-24 mb-0\">140,000</h3></div></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "149",
              options: _ctx.instagramCampaigns,
              series: _ctx.campaigns
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}